"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var userAgent = _ref.navigator.userAgent;
  return /bot|google|phantom|crawler|spider|crawling|headless|slurp|facebookexternal|Lighthouse|PTST|^mozilla\/4\.0$|^\s*$/i.test(userAgent);
};

exports["default"] = _default;
//# sourceMappingURL=isBot.js.map